module.exports = __webpack_public_path__ + "static/media/ss.c8e5f380.svg";